<template>
    <div
        :id="id"
        class="selection-list-wrapper"
    >
        <div class="selection-list">
            <SelectionListTile
                v-for="(item, index) in items"
                :key="index"
                :loading="loading"
                :item="item"
                @click="chooseItem(item)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { SelectionListItem } from 'widget-components/integrations/CustomPage/types'
import SelectionListTile from './SelectionListTile.vue'

defineOptions({ inheritAttrs: false })

defineProps<{
    id?: string
    items: SelectionListItem[]
    loading?: boolean
}>()

const emit = defineEmits(['itemChosen'])

const chooseItem = (item: SelectionListItem) => {
    emit('itemChosen', item)
}
</script>

<style lang="sass" scoped>
@import './SelectionList.sass'
</style>
